/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { Icon } from '@mayoral/ui';
import {
  Alert,
  AlertColor,
  AlertTitle,
  IconButton,
  Snackbar as MuiSnackbar,
  SnackbarProps as MuiSnackbarProps,
} from '@mui/material';
import { alertClasses } from '@mui/material/Alert';
import { styled } from '@mui/material/styles';
import { FC } from 'react';

const SnackbarAlert = styled(Alert, {
  name: 'Snackbar',
  slot: 'Alert',
})(() => ({
  [`& .${alertClasses.message}`]: {
    maxWidth: 285,
    wordBreak: 'bread-word',
  },
}));

type SnackbarProps = {
  open: boolean;
  handleClose: MuiSnackbarProps['onClose'];
  duration?: number;
  severity: AlertColor;
  message: string;
  title: string;
};

const Snackbar: FC<SnackbarProps> = ({ open, handleClose, duration, severity, message, title }) => {
  return (
    <MuiSnackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      key={message}
    >
      <SnackbarAlert
        severity={severity}
        action={
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={(event) => handleClose(event, 'escapeKeyDown')}
          >
            <Icon name="CloseS" />
          </IconButton>
        }
      >
        {title && <AlertTitle>{title}</AlertTitle>} {message}
      </SnackbarAlert>
    </MuiSnackbar>
  );
};

export default Snackbar;
